webpackJsonp([1,2],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return routes; });
var config = __webpack_require__(35);

var routes = [{
  name: 'Circle: mount',
  path: '/circle-mount',
  component: __webpack_require__(114)
}, {
  name: 'Circle: size controller',
  path: '/size-controller',
  component: __webpack_require__(117)
}, {
  name: 'Bars: styles',
  path: '/bars-styles',
  component: __webpack_require__(107)
}, {
  name: 'Pie chart: local component & props',
  path: '/pie-chart-local-component',
  folder: true,
  component: __webpack_require__(115)
}, {
  name: 'Basic map: html tooltip & events',
  path: '/basic-map-tooltip',
  folder: true,
  component: __webpack_require__(108)
}, {
  name: 'Bubbles: nested routes',
  path: '/bubbles-nested-routes',
  alias: '/bubbles-nested-routes/*',
  folder: true,
  component: __webpack_require__(112)
}].map(function (r) {
  var res = r;
  res.source = config.githubLink + config.d3ComponentsPath + r.path + (r.folder ? '' : '.vue');
  return res;
});

/***/ }),
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */
/***/ (function(module, exports) {

module.exports = {
	"githubLink": "https://github.com/corpglory/d3vue/",
	"d3ComponentsPath": "tree/master/src/d3-components"
};

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_router__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_index__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__demos__ = __webpack_require__(13);






__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_vue_router___default.a);

/* harmony default export */ __webpack_exports__["a"] = new __WEBPACK_IMPORTED_MODULE_2_vue_router___default.a({
  routes: [{
    path: '/',
    name: 'Menu',
    component: __WEBPACK_IMPORTED_MODULE_3_components_index___default.a
  }].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_4__demos__["a" /* routes */]))
});

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(97)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(39),
  /* template */
  __webpack_require__(126),
  /* scopeId */
  "data-v-41b7bac0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 38 */,
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_demos_navigation__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_demos_navigation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_demos_navigation__);




/* harmony default export */ __webpack_exports__["default"] = {
  name: 'app',
  components: { topNav: __WEBPACK_IMPORTED_MODULE_0__components_demos_navigation___default.a }
};

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_router_demos__ = __webpack_require__(13);



var config = __webpack_require__(35);

/* harmony default export */ __webpack_exports__["default"] = {
  computed: {
    prev: function prev() {
      var index = this.findIndex();
      if (index == -1) {
        return undefined;
      }
      return index > 0 ? __WEBPACK_IMPORTED_MODULE_0_router_demos__["a" /* routes */][index - 1] : undefined;
    },
    next: function next() {
      var index = this.findIndex();
      if (index == -1) {
        return undefined;
      }
      return index + 1 < __WEBPACK_IMPORTED_MODULE_0_router_demos__["a" /* routes */].length ? __WEBPACK_IMPORTED_MODULE_0_router_demos__["a" /* routes */][index + 1] : undefined;
    },
    sourceHref: function sourceHref() {
      var index = this.findIndex();
      if (index == -1) {
        return config.githubLink;
      }
      return __WEBPACK_IMPORTED_MODULE_0_router_demos__["a" /* routes */][index].source;
    }
  },
  methods: {
    findIndex: function findIndex() {
      var me = this.$route.name;
      return __WEBPACK_IMPORTED_MODULE_0_router_demos__["a" /* routes */].findIndex(function (r) {
        return r.name === me;
      });
    }
  }
};

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_router_demos__ = __webpack_require__(13);




/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      items: __WEBPACK_IMPORTED_MODULE_0_router_demos__["a" /* routes */]
    };
  }
};

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var d3 = __webpack_require__(1);

/* harmony default export */ __webpack_exports__["default"] = {
  mounted: function mounted() {

    var svg = d3.select(this.$el);
    var width = +svg.attr('width');
    var height = +svg.attr('height');

    var data = [{ name: 'one', val: 100 }, { name: 'two', val: 150 }, { name: 'three', val: 200 }];

    var x = d3.scaleBand().rangeRound([0, width]).padding(0.1).domain(data.map(function (d) {
      return d.name;
    }));
    var y = d3.scaleLinear().rangeRound([height * 0.3 - 20, 0]).domain([0, d3.max(data, function (d) {
      return d.val;
    })]);

    function addRectsWithName(elem, name) {
      elem.append('text').text(name).attr('x', width / 2).attr('y', 5).attr('text-anchor', 'middle');
      elem.selectAll('rect').data(data).enter().append('rect').attr('x', function (d) {
        return x(d.name);
      }).attr('class', function (d) {
        return d.name;
      }).attr('y', function (d) {
        return y(d.val);
      }).attr('width', x.bandwidth()).attr('height', function (d) {
        return y.range()[0] - y(d.val);
      });
    }

    svg.append('g').attr('id', 'bars-style').attr('transform', 'translate(0, 20)').call(addRectsWithName, 'Basic styles');

    var STYLE_MODULE_NAME = this.$el.attributes[0].name;
    svg.append('g').attr('transform', 'translate(0, ' + (height * 0.3 + 20) + ')').call(addRectsWithName, 'Scoped styles').selectAll('rect').attr(STYLE_MODULE_NAME, '');

    svg.append('g').attr('id', 'bars-style-sass').attr('transform', 'translate(0, ' + (height * 0.6 + 20) + ')').call(addRectsWithName, 'Sass styles');
  }
};

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_dsv__ = __webpack_require__(88);


var _ = __webpack_require__(3);

var map = __webpack_require__(109);
var tooltip = __webpack_require__(110);

var STATES_DATA_PATH = 'static/data/states-data.csv';



/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    usMap: map,
    tooltip: tooltip
  },
  created: function created() {
    var that = this;

    this.$http.get(STATES_DATA_PATH).then(function (res) {
      this.statesData = {};
      __WEBPACK_IMPORTED_MODULE_0_d3_dsv__["a" /* dsvFormat */](';').parse(res.data, function (d) {
        var population = d["2017 Population"].split(',').join('');
        d.value = +population;
        that.statesData[d.STATE_ABBR] = d;
        delete d["2017 Population"];
        delete d["STATE_ABBR"];
        return d;
      });
    });
  },
  data: function data() {
    return {
      statesData: undefined,
      currentState: undefined
    };
  },
  computed: {
    currentStateDescription: function currentStateDescription() {
      return "Population: " + this.currentState.value;
    }
  },
  methods: {
    onStateSelected: function onStateSelected(stateCode) {
      this.currentState = this.statesData[stateCode];
    },
    onStateDeselected: function onStateDeselected(stateCode) {
      this.currentState = undefined;
    }
  }
};

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var d3 = __webpack_require__(1);
var topojson = __webpack_require__(104);

/* harmony default export */ __webpack_exports__["default"] = {
  mounted: function mounted() {
    var v = this;
    var svg = d3.select(this.$el);
    var width = +svg.attr('width');
    var height = +svg.attr('height');

    var projection = d3.geoAlbersUsa();
    var path = d3.geoPath().projection(projection);

    d3.json("static/data/us.json", function (error, us) {
      var g = svg.append('g');
      g.selectAll('.state').data(topojson.feature(us, us.objects.usStates).features).enter().append("path").attr("class", "state").attr("d", path).on('mouseover', function (d) {
        v.$emit('stateSelected', d.properties.STATE_ABBR);
      }).on('mouseout', function (d) {
        v.$emit('stateDeselected', d.properties.STATE_ABBR);
      });
      g.attr('transform', 'scale(0.57)');
    });
  }
};

/***/ }),
/* 45 */
/***/ (function(module, exports) {



module.exports = {
  name: 'tooltip',
  props: ['title', 'description']
};

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ph2_index__ = __webpack_require__(53);



var d3 = __webpack_require__(1);

/* harmony default export */ __webpack_exports__["default"] = {
  props: ['groupBy', 'data'],
  watch: {
    groupBy: function groupBy(_groupBy) {
      this.ph2.setLayout(_groupBy);
    },
    data: function data(_data) {
      this.ph2.setData(_data);
    }
  },
  mounted: function mounted() {
    var svg = d3.select(this.$el);
    var width = +svg.attr('width');
    var height = +svg.attr('height');

    var that = this;
    var bubblesG = svg.append('g').attr('transform', 'translate(' + width / 2 + ', ' + height / 2 + ')');

    d3.csv('static/data/earthquakes.csv', function (data) {
      that.ph2 = new __WEBPACK_IMPORTED_MODULE_0__ph2_index__["a" /* default */](bubblesG, data, that.groupBy);
    });
  }

};

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var menu = __webpack_require__(113);
var bubbles = __webpack_require__(111);

var MY_URL_PREFIX = 'bubbles-nested-routes';
var _ = __webpack_require__(3);

var LINKS = [{
  name: 'None',
  path: '',
  layout: 'total'
}, {
  name: 'By country',
  path: '/country',
  layout: 'country'
}, {
  name: 'By day',
  path: '/day',
  layout: 'day'
}].map(function (d) {
  d.path = '#/' + MY_URL_PREFIX + d.path;
  d.active = false;
  return d;
});

/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    groupMenu: menu,
    bubbles: bubbles
  },
  data: function data() {
    return {
      activeLink: this.findActiveLink()
    };
  },
  computed: {
    links: function links() {
      return LINKS;
    }
  },
  methods: {
    findActiveLink: function findActiveLink() {
      var _this = this;

      _.each(LINKS, function (l) {
        l.active = false;
      });
      var link = _.find(LINKS, function (l) {
        return l.path == '#' + _this.$route.path;
      });
      if (!link) {
        link = LINKS[0];
      }
      return link;
    }
  },
  watch: {
    '$route': function $route(to, from) {
      this.activeLink = this.findActiveLink();
    }
  }
};

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var _ = __webpack_require__(3);

/* harmony default export */ __webpack_exports__["default"] = {
  props: ['links', 'activeLink'],
  computed: {
    alinks: function alinks() {
      var that = this;
      return _.map(this.links, function (l) {
        return {
          item: l,
          active: l.path == that.activeLink.path
        };
      });
    }
  }
};

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var d3 = __webpack_require__(1);
/* harmony default export */ __webpack_exports__["default"] = {
  mounted: function mounted() {
    d3.select(this.$el).append('circle').attr('cx', '250').attr('cy', '150').attr('r', '100');
  }
};

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var _ = __webpack_require__(3);
var pie = __webpack_require__(116);

var NAMES = [{ name: 'Sarah', value: 2502 }, { name: 'Emma', value: 2005 }, { name: 'Laura', value: 1968 }, { name: 'Chloé', value: 1863 }, { name: 'Marie', value: 1810 }, { name: 'Emily', value: 1637 }, { name: 'Léa', value: 1592 }, { name: 'Camille', value: 1572 }, { name: 'Anna', value: 1433 }, { name: 'Manon', value: 1403 }];

/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    pie: pie
  },
  data: function data() {
    return {
      names: _.take(NAMES, 3)
    };
  },
  computed: {
    canAddAName: function canAddAName() {
      return this.names.length < NAMES.length;
    }
  },
  methods: {
    addName: function addName() {
      this.names.push(NAMES[this.names.length]);
    }
  }
};

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var d3 = __webpack_require__(1);

/* harmony default export */ __webpack_exports__["default"] = {
  mounted: function mounted() {
    var svg = d3.select(this.$el);
    var width = +svg.attr('width');
    var height = +svg.attr('height');

    var margin = { top: 20, left: 0, bottom: 30, right: 0 };

    var chartWidth = width - (margin.left + margin.right);
    var chartHeight = height - (margin.top + margin.bottom);

    this.chartLayer = svg.append('g').attr("transform", 'translate(' + margin.left + ', ' + margin.top + ')');

    this.arc = d3.arc().outerRadius(chartHeight / 2).innerRadius(chartHeight / 4).padAngle(0.03).cornerRadius(8);

    this.pieG = this.chartLayer.append("g").attr("transform", 'translate(' + chartWidth / 2 + ', ' + chartHeight / 2 + ')');

    this.drawChart(this.data);
  },
  props: ['data'],
  watch: {
    data: function data(newData) {
      this.drawChart(newData);
    }
  },
  methods: {
    drawChart: function drawChart(data) {
      var arcs = d3.pie().sort(null).value(function (d) {
        return d.value;
      })(data);

      var block = this.pieG.selectAll(".arc").data(arcs);

      block.select('path').attr('d', this.arc);

      var newBlock = block.enter().append("g").classed("arc", true);

      newBlock.append("path").attr("d", this.arc).attr("id", function (d, i) {
        return "arc-" + i;
      }).attr("stroke", "gray").attr("fill", function (d) {
        return d3.interpolateCool(Math.random());
      });

      newBlock.append("text").attr("dx", 10).attr("dy", -5).append("textPath").attr("xlink:href", function (d, i) {
        return "#arc-" + i;
      }).text(function (d) {
        return d.data.name;
      });
    }
  }
};

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var d3 = __webpack_require__(1);
/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      circleSize: 50
    };
  },
  mounted: function mounted(createElement) {
    var svg = d3.select(this.$el).select('svg');
    this.circle = svg.append('circle').attr('cx', '250').attr('cy', '150').attr('r', this.circleSize);
  },
  watch: {
    circleSize: function circleSize(newValue) {
      this.circle.attr('r', newValue);
    }
  }

};

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout_total__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__layout_contry__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__layout_day__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);








var d3 = __webpack_require__(1);


var PH2 = function () {
  function PH2(elem, data, layoutName) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, PH2);

    this.svg = elem;
    this.data = data;
    this.setData(data);
    this._init();
    this.layout = undefined;
    this.setLayout(layoutName);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(PH2, [{
    key: 'setLayout',
    value: function setLayout(layoutName) {

      if (layoutName === undefined) {
        throw new Error('layoutName is undefined');
      }
      if (!this.layouts) {
        throw new Error('Layouts are not defined');
      }
      if (!this.layouts[layoutName]) {
        throw new Error('Can`t find layout ' + layoutName);
      }

      if (this.layout) {
        this.layout.exit();
      }
      this.layout = this.layouts[layoutName];
      if (!this.layout.inited) {
        this.layout.init();
        this.layout.inited = true;
      }
      this.layout.enter();
      this.simulation.alpha(1);
      this.simulation.restart();
    }
  }, {
    key: 'setData',
    value: function setData(data) {
      this.nodes = data.map(function (d) {
        return {
          r: +d.Magnitude
        };
      });
    }
  }, {
    key: '_init',
    value: function _init() {
      this.simulation = d3.forceSimulation().force("index-collide", d3.forceCollide(function (d) {
        return d.r + 5;
      }).iterations(16)).force("index-x", d3.forceX().strength(0.04)).force("index-y", d3.forceY().strength(0.04));

      this._initLayouts();

      var node = this.svg.append("g").attr("class", "nodes").selectAll("circle").data(this.nodes).enter().append("circle").attr("r", function (d) {
        return d.r;
      });

      var that = this;
      var ticked = function ticked() {
        node.attr("cx", function (d) {
          return d.x;
        }).attr("cy", function (d) {
          return d.y;
        });
        if (that.layout.ticked) {
          that.layout.ticked();
        }
      };

      this.simulation.nodes(this.nodes).on("tick", ticked);
    }
  }, {
    key: '_initLayouts',
    value: function _initLayouts() {
      this.layouts = {
        'total': __WEBPACK_IMPORTED_MODULE_2__layout_total__["a" /* default */],
        'country': __WEBPACK_IMPORTED_MODULE_3__layout_contry__["a" /* default */],
        'day': __WEBPACK_IMPORTED_MODULE_4__layout_day__["a" /* default */]
      };

      for (var k in this.layouts) {
        var v = this.layouts[k];
        this.layouts[k] = new v(this.svg, this.data, this.simulation);
      }
    }
  }]);

  return PH2;
}();

/* harmony default export */ __webpack_exports__["a"] = PH2;

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);


var d3 = __webpack_require__(1);
var _ = __webpack_require__(3);

var _class = function () {
  function _class(elem, data, simulation) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, _class);

    this.elem = elem;
    this.data = data;
    this.simulation = simulation;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(_class, [{
    key: 'init',
    value: function init() {
      var groups = _(this.data).map(function (k, i) {
        return {
          location: k.Location.split(', ')[1],
          index: i
        };
      }).groupBy('location').value();

      this.countries = _.map(groups, function (v, k) {
        return { key: k, r: -30 };
      });

      this.links = [];
      console.log(groups[this.countries[0].key][0]);
      for (var i = 0; i < this.countries.length; i++) {
        for (var j = 0; j < groups[this.countries[i].key].length; j++) {
          this.links.push({
            source: i + this.data.length,
            target: groups[this.countries[i].key][j].index
          });
        }
      }
    }
  }, {
    key: 'enter',
    value: function enter() {

      this.nodesBefore = this.simulation.nodes();
      this.simulation.force("country-link", d3.forceLink().id(function (d) {
        return d.index;
      })).force("country-charge", d3.forceManyBody().strength(-30)).force("country-x", d3.forceX().strength(0.11)).force("country-y", d3.forceY().strength(0.11));

      this.simulation.force("link");

      this.simulation.nodes(_.concat(this.nodesBefore, this.countries));

      this.countryG = this.elem.append("g");
      this.countyLabels = this.countryG.selectAll('text').data(this.countries).enter().append('text').text(function (d) {
        return d.key;
      }).attr("text-anchor", "middle").attr("font-size", "8");

      this.linesG = this.elem.insert("g", ":first-child");
      this.lines = this.linesG.selectAll("line").data(this.links).enter().append("line").attr("stroke", "#d7d7d7");

      this.simulation.force("country-link").links(this.links);
    }
  }, {
    key: 'ticked',
    value: function ticked() {
      this.lines.attr("x1", function (d) {
        return d.source.x;
      }).attr("y1", function (d) {
        return d.source.y;
      }).attr("x2", function (d) {
        return d.target.x;
      }).attr("y2", function (d) {
        return d.target.y;
      });
      this.countyLabels.attr('x', function (d) {
        return d.x;
      }).attr('y', function (d) {
        return d.y;
      });
    }
  }, {
    key: 'exit',
    value: function exit() {
      this.simulation.nodes(this.nodesBefore);
      this.simulation.force("country-link", null).force("country-charge", null).force("country-x", null).force("country-y", null);

      this.linesG.remove();
      this.countryG.remove();
    }
  }]);

  return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = _class;

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);


var d3 = __webpack_require__(1);
var _ = __webpack_require__(3);

var DAY_RANGE = d3.range(14, 24);
var WIDTH = 500;

var _class = function () {
  function _class(elem, data, simulation) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, _class);

    this.elem = elem;
    this.data = data;
    this.simulation = simulation;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(_class, [{
    key: 'init',
    value: function init() {
      var _this = this;

      this.dayX = _.map(this.data, function (d) {
        return _this._dayToX(+d.Date.split('-')[0]);
      });
    }
  }, {
    key: 'enter',
    value: function enter() {
      this.forceIndexCollide = this.simulation.force("index-collide");
      this.simulation.force("index-collide", null);
      this.forceIndexY = this.simulation.force("index-y");
      this.simulation.force("index-y", null);

      this.simulation.force("day-collide", d3.forceCollide(function (d) {
        return d.r + 2;
      }).iterations(16));

      this.daysG = this.elem.append('g');

      this.daysG.selectAll('text').data(DAY_RANGE).enter().append('text').text(function (d) {
        return d;
      }).attr('x', this._dayToX).attr('font-size', 10).attr('fill', 'gray').attr('text-anchor', 'middle');

      var that = this;
      this.simulation.force('day-x', d3.forceX(function (d) {
        return that.dayX[d.index];
      }).strength(1));
      this.simulation.force("day-y", d3.forceY().strength(0.005));
    }
  }, {
    key: 'exit',
    value: function exit() {
      this.daysG.remove();
      this.simulation.force('day-x', null);
      this.simulation.force("index-collide", this.forceIndexCollide);
      this.simulation.force("index-y", this.forceIndexY);
    }
  }, {
    key: '_dayToX',
    value: function _dayToX(day) {
      return (day - DAY_RANGE[0]) * WIDTH / DAY_RANGE.length - WIDTH * 0.48;
    }
  }]);

  return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = _class;

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var _class = function () {
  function _class(elem, data, simulation) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, _class);

    this.elem = elem;
    this.simulation = simulation;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(_class, [{
    key: "init",
    value: function init() {}
  }, {
    key: "enter",
    value: function enter() {}
  }, {
    key: "exit",
    value: function exit() {}
  }]);

  return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = _class;

/***/ }),
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 92 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 93 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 94 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 95 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 96 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 97 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 98 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 99 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 100 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 101 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 102 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 103 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 104 */,
/* 105 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(91)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(40),
  /* template */
  __webpack_require__(119),
  /* scopeId */
  "data-v-098bb42e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(96)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(41),
  /* template */
  __webpack_require__(125),
  /* scopeId */
  "data-v-417810ac",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(101)
__webpack_require__(102)
__webpack_require__(100)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(42),
  /* template */
  __webpack_require__(130),
  /* scopeId */
  "data-v-63d4ce13",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(95)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(43),
  /* template */
  __webpack_require__(123),
  /* scopeId */
  "data-v-39fd153a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(92)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(44),
  /* template */
  __webpack_require__(120),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(99)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(45),
  /* template */
  __webpack_require__(129),
  /* scopeId */
  "data-v-6039702a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(46),
  /* template */
  __webpack_require__(124),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(93)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(47),
  /* template */
  __webpack_require__(121),
  /* scopeId */
  "data-v-28f41ffe",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(94)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(48),
  /* template */
  __webpack_require__(122),
  /* scopeId */
  "data-v-37ada400",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(103)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(49),
  /* template */
  __webpack_require__(131),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(50),
  /* template */
  __webpack_require__(118),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(51),
  /* template */
  __webpack_require__(128),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(98)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(52),
  /* template */
  __webpack_require__(127),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 118 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', [_vm._v("Most popular female names in the world")]), _vm._v(" "), _c('pie', {
    attrs: {
      "data": _vm.names
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.canAddAName) ? _c('button', {
    on: {
      "click": _vm.addName
    }
  }, [_vm._v("Add a name")]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 119 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "holder"
    }
  }, [_c('div', {
    staticClass: "links"
  }, [(_vm.prev) ? _c('router-link', {
    staticClass: "prev",
    attrs: {
      "to": _vm.prev.path
    }
  }, [_vm._v(" < prev ")]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "source",
    attrs: {
      "href": _vm.sourceHref
    }
  }, [_vm._v(" source ")]), _vm._v(" "), (_vm.next) ? _c('router-link', {
    staticClass: "next",
    attrs: {
      "to": _vm.next.path
    }
  }, [_vm._v(" next > ")]) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 120 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "500",
      "height": "300"
    }
  })
},staticRenderFns: []}

/***/ }),
/* 121 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "holder"
  }, [_c('groupMenu', {
    attrs: {
      "links": _vm.links,
      "activeLink": _vm.activeLink
    }
  }), _vm._v(" "), _c('bubbles', {
    attrs: {
      "groupBy": _vm.activeLink.layout
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 122 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "holder"
  }, [_c('ul', {
    staticClass: "menu"
  }, [_c('li', [_vm._v("Group by: ")]), _vm._v(" "), _vm._l((_vm.alinks), function(link) {
    return _c('li', [_c('a', {
      class: {
        active: link.active
      },
      attrs: {
        "href": link.item.path
      }
    }, [_vm._v(" " + _vm._s(link.item.name) + " ")])])
  })], 2)])
},staticRenderFns: []}

/***/ }),
/* 123 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "holder"
    }
  }, [_c('div', {
    staticClass: "mapHolder"
  }, [_c('us-map', {
    on: {
      "stateSelected": _vm.onStateSelected,
      "stateDeselected": _vm.onStateDeselected
    }
  })], 1), _vm._v(" "), (_vm.currentState) ? _c('tooltip', {
    attrs: {
      "title": _vm.currentState.Name,
      "description": _vm.currentStateDescription
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 124 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "600",
      "height": "500"
    }
  })
},staticRenderFns: []}

/***/ }),
/* 125 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello"
  }, [_c('ul', _vm._l((_vm.items), function(item) {
    return _c('li', [_c('router-link', {
      attrs: {
        "to": item.path
      }
    }, [_vm._v(_vm._s(item.name))])], 1)
  }))])
},staticRenderFns: []}

/***/ }),
/* 126 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_vm._m(0), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$route.name))]), _vm._v(" "), _c('top-nav'), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#/"
    }
  }, [_c('h1', [_vm._v(" D3.js vs Vue.js examples ")])])
}]}

/***/ }),
/* 127 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('svg', {
    attrs: {
      "width": "500",
      "height": "300"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.circleSize),
      expression: "circleSize"
    }],
    attrs: {
      "type": "range",
      "min": "1",
      "max": "100",
      "step": "1"
    },
    domProps: {
      "value": _vm._s(_vm.circleSize)
    },
    on: {
      "input": function($event) {
        _vm.circleSize = $event.target.value
      }
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 128 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "500",
      "height": "300"
    }
  })
},staticRenderFns: []}

/***/ }),
/* 129 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "tooltipPositioner"
    }
  }, [_c('div', {
    attrs: {
      "id": "tooltip"
    }
  }, [_c('div', {
    attrs: {
      "id": "tooltipContainer"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.description))])])])])
},staticRenderFns: []}

/***/ }),
/* 130 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "500",
      "height": "300"
    }
  })
},staticRenderFns: []}

/***/ }),
/* 131 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "500",
      "height": "300"
    }
  })
},staticRenderFns: []}

/***/ }),
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_resource__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_resource___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_resource__);






__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_3_vue_resource___default.a);

new __WEBPACK_IMPORTED_MODULE_0_vue___default.a({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<app/>',
  components: { app: __WEBPACK_IMPORTED_MODULE_1__app___default.a }
});

/***/ })
],[136]);


// WEBPACK FOOTER //
// static/js/app.bb478689be3640ebf141.js